/*import { createStore } from 'vuex'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})*/
import { createStore } from 'vuex'

export default createStore({
  state: {
    auth: {
      isAuthenticated: false, // Estado inicial de autenticación,
      roles: [],
    },
    /*user: {
      roles: [] // Almacena los roles del usuario
    }*/
  },
  getters: {
  },
  mutations: {
    setIsAuthenticated(state, isAuthenticated) {
      state.auth.isAuthenticated = isAuthenticated;
    },
    setUserRoles(state, roles) {
      state.auth.roles = [roles];
      localStorage.setItem('userRoles', [roles]); //para que al actualizar no se pierda la informacion
    },
   
    
  },
  actions: {
  },
  modules: {
  }
})